import { render, staticRenderFns } from "./ThemesAssigmentDropdown.vue?vue&type=template&id=9f0369b2&"
import script from "./ThemesAssigmentDropdown.vue?vue&type=script&lang=ts&"
export * from "./ThemesAssigmentDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports